import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/EmailTest.css';

const EmailTest = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, checking, sending, success, error
  const [message, setMessage] = useState('');
  const [config, setConfig] = useState(null);

  // Check configuration on mount
  useEffect(() => {
    checkConfiguration();
  }, []);

  const checkConfiguration = async () => {
    setStatus('checking');
    try {
      const response = await axios.get('/api/test-email/status');
      setConfig(response.data);
      
      if (response.data.configured) {
        setMessage('✅ Zoho Mail API está configurado correctamente');
      } else {
        setMessage('⚠️ Zoho Mail API não está totalmente configurado');
      }
      setStatus('idle');
    } catch (error) {
      setMessage('❌ Erro ao verificar configuração');
      setStatus('error');
    }
  };

  const sendTestEmail = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage('❌ Por favor, insira um email válido');
      return;
    }

    setStatus('sending');
    setMessage('📧 A enviar email de teste...');

    try {
      const response = await axios.post('/api/test-email', {
        to: email,
        testMode: true
      });

      setStatus('success');
      setMessage(`✅ Email de teste enviado com sucesso para ${email}!`);
      
      // Clear form after 3 seconds
      setTimeout(() => {
        setEmail('');
        setStatus('idle');
      }, 3000);

    } catch (error) {
      setStatus('error');
      const errorMsg = error.response?.data?.message || error.message;
      setMessage(`❌ Erro ao enviar email: ${errorMsg}`);
      console.error('Email test error:', error.response?.data);
    }
  };

  return (
    <div className="email-test-container">
      <div className="email-test-card">
        <div className="email-test-header">
          <h2>🧪 Teste de Email - Zoho Mail API</h2>
          <p>Verifica se o sistema de emails está a funcionar correctamente</p>
        </div>

        {/* Configuration Status */}
        {config && (
          <div className={`config-status ${config.configured ? 'configured' : 'not-configured'}`}>
            <h3>Estado da Configuração</h3>
            <div className="config-grid">
              <div className="config-item">
                <span className="config-label">Client ID:</span>
                <span className={`config-value ${config.variables.ZOHO_CLIENT_ID ? 'ok' : 'missing'}`}>
                  {config.variables.ZOHO_CLIENT_ID ? '✅ Configurado' : '❌ Não configurado'}
                </span>
              </div>
              <div className="config-item">
                <span className="config-label">Client Secret:</span>
                <span className={`config-value ${config.variables.ZOHO_CLIENT_SECRET ? 'ok' : 'missing'}`}>
                  {config.variables.ZOHO_CLIENT_SECRET ? '✅ Configurado' : '❌ Não configurado'}
                </span>
              </div>
              <div className="config-item">
                <span className="config-label">Refresh Token:</span>
                <span className={`config-value ${config.variables.ZOHO_REFRESH_TOKEN ? 'ok' : 'missing'}`}>
                  {config.variables.ZOHO_REFRESH_TOKEN ? '✅ Configurado' : '❌ Não configurado'}
                </span>
              </div>
              <div className="config-item">
                <span className="config-label">From Email:</span>
                <span className={`config-value ${config.variables.ZOHO_FROM_EMAIL ? 'ok' : 'missing'}`}>
                  {config.fromEmail}
                </span>
              </div>
              <div className="config-item">
                <span className="config-label">Region:</span>
                <span className="config-value ok">{config.region}</span>
              </div>
            </div>
          </div>
        )}

        {/* Test Form */}
        <form onSubmit={sendTestEmail} className="email-test-form">
          <div className="form-group">
            <label htmlFor="test-email">Email de Destino:</label>
            <input
              type="email"
              id="test-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu-email@exemplo.com"
              required
              disabled={status === 'sending'}
            />
            <small>Insira o email onde quer receber o teste</small>
          </div>

          <button 
            type="submit" 
            className={`btn-test ${status}`}
            disabled={status === 'sending' || status === 'checking'}
          >
            {status === 'sending' ? '📧 A Enviar...' : '📨 Enviar Email de Teste'}
          </button>
        </form>

        {/* Status Message */}
        {message && (
          <div className={`status-message ${status}`}>
            {message}
          </div>
        )}

        {/* Instructions */}
        <div className="test-instructions">
          <h3>ℹ️ Como Funciona:</h3>
          <ol>
            <li>Insira o seu email no campo acima</li>
            <li>Clique em "Enviar Email de Teste"</li>
            <li>Verifique a sua caixa de entrada (e spam)</li>
            <li>Se receber o email, o sistema está a funcionar!</li>
          </ol>
          
          <div className="test-note">
            <strong>Nota:</strong> O email de teste inclui informações sobre a configuração e timestamp para confirmar que tudo está operacional.
          </div>
        </div>

        {/* Refresh Config Button */}
        <button 
          onClick={checkConfiguration}
          className="btn-refresh"
          disabled={status === 'checking'}
        >
          🔄 Verificar Configuração Novamente
        </button>
      </div>
    </div>
  );
};

export default EmailTest;
